// source: no/jotta/openapi/subscription/payment.v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_ping_pb = require('../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var no_jotta_openapi_language_pb = require('../../../../no/jotta/openapi/language_pb.js');
goog.object.extend(proto, no_jotta_openapi_language_pb);
var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var no_jotta_protobuf_wrappers_pb = require('../../../../no/jotta/protobuf/wrappers_pb.js');
goog.object.extend(proto, no_jotta_protobuf_wrappers_pb);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.Card', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.StatusCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CreditCardExpired', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.Currency', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetOrderRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetOrderResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ChangeSubscriptionOptionCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.TypeCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.HasPaymentIssues', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.ListOrdersRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.ListOrdersResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.Money', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.NoPaymentMethod', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.Order', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.Order.OrderStatus', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.Order.OrderType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.OrderItem', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PayPal', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PaymentInfo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PaymentInfo.PaymentMethodCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PaymentInterval', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.TypeCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.TypeCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.RecurringSubscriptionInterval', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.StripeClientState', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.SubscriptionInterval', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.SubscriptionMessage', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.MessageCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.subscription.v2.VippsBilling', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.Money = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.Money, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.Money.displayName = 'proto.no.jotta.openapi.subscription.v2.Money';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PaymentInterval, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PaymentInterval.displayName = 'proto.no.jotta.openapi.subscription.v2.PaymentInterval';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.VippsBilling, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.VippsBilling.displayName = 'proto.no.jotta.openapi.subscription.v2.VippsBilling';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.Card = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.Card, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.Card.displayName = 'proto.no.jotta.openapi.subscription.v2.Card';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PayPal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PayPal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PayPal.displayName = 'proto.no.jotta.openapi.subscription.v2.PayPal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.NoPaymentMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.NoPaymentMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.displayName = 'proto.no.jotta.openapi.subscription.v2.NoPaymentMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.subscription.v2.PaymentInfo.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PaymentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PaymentInfo.displayName = 'proto.no.jotta.openapi.subscription.v2.PaymentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.displayName = 'proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.displayName = 'proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpired = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CreditCardExpired, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CreditCardExpired.displayName = 'proto.no.jotta.openapi.subscription.v2.CreditCardExpired';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.HasPaymentIssues = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.HasPaymentIssues, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.displayName = 'proto.no.jotta.openapi.subscription.v2.HasPaymentIssues';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.displayName = 'proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.SubscriptionMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.displayName = 'proto.no.jotta.openapi.subscription.v2.SubscriptionMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.repeatedFields_, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.displayName = 'proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.displayName = 'proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.displayName = 'proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.displayName = 'proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.StripeClientState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.StripeClientState.displayName = 'proto.no.jotta.openapi.subscription.v2.StripeClientState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.displayName = 'proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.displayName = 'proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.displayName = 'proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.displayName = 'proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.displayName = 'proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.displayName = 'proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.displayName = 'proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.displayName = 'proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.displayName = 'proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.displayName = 'proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.OrderItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.OrderItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.OrderItem.displayName = 'proto.no.jotta.openapi.subscription.v2.OrderItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.Order = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.subscription.v2.Order.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.Order, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.Order.displayName = 'proto.no.jotta.openapi.subscription.v2.Order';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetOrderRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.GetOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.GetOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.GetOrderResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.GetOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.ListOrdersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.ListOrdersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.ListOrdersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.ListOrdersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.displayName = 'proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.displayName = 'proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.Money.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.Money.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.Money} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.Money.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.openapi.subscription.v2.Money.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.Money;
  return proto.no.jotta.openapi.subscription.v2.Money.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.Money} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.openapi.subscription.v2.Money.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.Currency} */ (reader.readEnum());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.Money.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.Money.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.Money} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.Money.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int64 amount = 1;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Money.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Money} returns this
 */
proto.no.jotta.openapi.subscription.v2.Money.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Currency currency = 2;
 * @return {!proto.no.jotta.openapi.subscription.v2.Currency}
 */
proto.no.jotta.openapi.subscription.v2.Money.prototype.getCurrency = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.Currency} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Currency} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Money} returns this
 */
proto.no.jotta.openapi.subscription.v2.Money.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PaymentInterval.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.toObject = function(includeInstance, msg) {
  var f, obj = {
    interval: jspb.Message.getFieldWithDefault(msg, 1, 0),
    price: (f = msg.getPrice()) && proto.no.jotta.openapi.subscription.v2.Money.toObject(includeInstance, f),
    priceBeforeDiscount: (f = msg.getPriceBeforeDiscount()) && proto.no.jotta.openapi.subscription.v2.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PaymentInterval;
  return proto.no.jotta.openapi.subscription.v2.PaymentInterval.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.subscription.v2.Money;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Money.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.subscription.v2.Money;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Money.deserializeBinaryFromReader);
      msg.setPriceBeforeDiscount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PaymentInterval.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.subscription.v2.Money.serializeBinaryToWriter
    );
  }
  f = message.getPriceBeforeDiscount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.subscription.v2.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionInterval interval = 1;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} returns this
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Money price = 2;
 * @return {?proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.getPrice = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Money} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.Money, 2));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Money|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} returns this
*/
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} returns this
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Money price_before_discount = 3;
 * @return {?proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.getPriceBeforeDiscount = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Money} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.Money, 3));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Money|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} returns this
*/
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.setPriceBeforeDiscount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval} returns this
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.clearPriceBeforeDiscount = function() {
  return this.setPriceBeforeDiscount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInterval.prototype.hasPriceBeforeDiscount = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentMethod: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest;
  return proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string payment_method = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientSecret: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse;
  return proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string client_secret = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateStripeIntentResponse.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentMethod: jspb.Message.getFieldWithDefault(msg, 1, ""),
    interval: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest;
  return proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string payment_method = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SubscriptionInterval interval = 2;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentRequest.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse;
  return proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ChangePaymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.VippsBilling.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.VippsBilling} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.toObject = function(includeInstance, msg) {
  var f, obj = {
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    paymentTicketId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.VippsBilling}
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.VippsBilling;
  return proto.no.jotta.openapi.subscription.v2.VippsBilling.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.VippsBilling} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.VippsBilling}
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentTicketId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.VippsBilling.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.VippsBilling} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPaymentTicketId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool is_active = 1;
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.subscription.v2.VippsBilling} returns this
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string payment_ticket_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.prototype.getPaymentTicketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.VippsBilling} returns this
 */
proto.no.jotta.openapi.subscription.v2.VippsBilling.prototype.setPaymentTicketId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.Card.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.Card} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.Card.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardMask: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cardExpiry: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cardVendor: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cardExpiresAtMillis: jspb.Message.getFieldWithDefault(msg, 4, 0),
    paymentTicketId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.Card}
 */
proto.no.jotta.openapi.subscription.v2.Card.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.Card;
  return proto.no.jotta.openapi.subscription.v2.Card.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.Card} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.Card}
 */
proto.no.jotta.openapi.subscription.v2.Card.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardMask(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardExpiry(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardVendor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardExpiresAtMillis(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentTicketId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.Card.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.Card} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.Card.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardMask();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCardExpiry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCardVendor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCardExpiresAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPaymentTicketId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string card_mask = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.getCardMask = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Card} returns this
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.setCardMask = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string card_expiry = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.getCardExpiry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Card} returns this
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.setCardExpiry = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string card_vendor = 3;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.getCardVendor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Card} returns this
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.setCardVendor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 card_expires_at_millis = 4;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.getCardExpiresAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Card} returns this
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.setCardExpiresAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string payment_ticket_id = 5;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.getPaymentTicketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Card} returns this
 */
proto.no.jotta.openapi.subscription.v2.Card.prototype.setPaymentTicketId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PayPal.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PayPal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PayPal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PayPal.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentTicketId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PayPal}
 */
proto.no.jotta.openapi.subscription.v2.PayPal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PayPal;
  return proto.no.jotta.openapi.subscription.v2.PayPal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PayPal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PayPal}
 */
proto.no.jotta.openapi.subscription.v2.PayPal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentTicketId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PayPal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PayPal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PayPal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PayPal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentTicketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string payment_ticket_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PayPal.prototype.getPaymentTicketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PayPal} returns this
 */
proto.no.jotta.openapi.subscription.v2.PayPal.prototype.setPaymentTicketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.NoPaymentMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.NoPaymentMethod}
 */
proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.NoPaymentMethod;
  return proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.NoPaymentMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.NoPaymentMethod}
 */
proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.NoPaymentMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.oneofGroups_ = [[1,2,6,7]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.PaymentMethodCase = {
  PAYMENT_METHOD_NOT_SET: 0,
  NO_PAYMENT: 1,
  CARD: 2,
  VIPPS_BILLING: 6,
  PAYPAL: 7
};

/**
 * @return {proto.no.jotta.openapi.subscription.v2.PaymentInfo.PaymentMethodCase}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.getPaymentMethodCase = function() {
  return /** @type {proto.no.jotta.openapi.subscription.v2.PaymentInfo.PaymentMethodCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.subscription.v2.PaymentInfo.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PaymentInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    noPayment: (f = msg.getNoPayment()) && proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.toObject(includeInstance, f),
    card: (f = msg.getCard()) && proto.no.jotta.openapi.subscription.v2.Card.toObject(includeInstance, f),
    vippsBilling: (f = msg.getVippsBilling()) && proto.no.jotta.openapi.subscription.v2.VippsBilling.toObject(includeInstance, f),
    paypal: (f = msg.getPaypal()) && proto.no.jotta.openapi.subscription.v2.PayPal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PaymentInfo;
  return proto.no.jotta.openapi.subscription.v2.PaymentInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.subscription.v2.NoPaymentMethod;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.deserializeBinaryFromReader);
      msg.setNoPayment(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.subscription.v2.Card;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Card.deserializeBinaryFromReader);
      msg.setCard(value);
      break;
    case 6:
      var value = new proto.no.jotta.openapi.subscription.v2.VippsBilling;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.VippsBilling.deserializeBinaryFromReader);
      msg.setVippsBilling(value);
      break;
    case 7:
      var value = new proto.no.jotta.openapi.subscription.v2.PayPal;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PayPal.deserializeBinaryFromReader);
      msg.setPaypal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PaymentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoPayment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.subscription.v2.NoPaymentMethod.serializeBinaryToWriter
    );
  }
  f = message.getCard();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.subscription.v2.Card.serializeBinaryToWriter
    );
  }
  f = message.getVippsBilling();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.no.jotta.openapi.subscription.v2.VippsBilling.serializeBinaryToWriter
    );
  }
  f = message.getPaypal();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.no.jotta.openapi.subscription.v2.PayPal.serializeBinaryToWriter
    );
  }
};


/**
 * optional NoPaymentMethod no_payment = 1;
 * @return {?proto.no.jotta.openapi.subscription.v2.NoPaymentMethod}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.getNoPayment = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.NoPaymentMethod} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.NoPaymentMethod, 1));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.NoPaymentMethod|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
*/
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.setNoPayment = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.subscription.v2.PaymentInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.clearNoPayment = function() {
  return this.setNoPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.hasNoPayment = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Card card = 2;
 * @return {?proto.no.jotta.openapi.subscription.v2.Card}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.getCard = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Card} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.Card, 2));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Card|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
*/
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.setCard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.subscription.v2.PaymentInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.clearCard = function() {
  return this.setCard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.hasCard = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional VippsBilling vipps_billing = 6;
 * @return {?proto.no.jotta.openapi.subscription.v2.VippsBilling}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.getVippsBilling = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.VippsBilling} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.VippsBilling, 6));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.VippsBilling|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
*/
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.setVippsBilling = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.no.jotta.openapi.subscription.v2.PaymentInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.clearVippsBilling = function() {
  return this.setVippsBilling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.hasVippsBilling = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PayPal paypal = 7;
 * @return {?proto.no.jotta.openapi.subscription.v2.PayPal}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.getPaypal = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.PayPal} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.PayPal, 7));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.PayPal|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
*/
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.setPaypal = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.no.jotta.openapi.subscription.v2.PaymentInfo.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInfo} returns this
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.clearPaypal = function() {
  return this.setPaypal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PaymentInfo.prototype.hasPaypal = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional no.jotta.openapi.Language language = 1;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.prototype.getLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer}
 */
proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer;
  return proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer}
 */
proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon;
  return proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpired.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CreditCardExpired.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CreditCardExpired} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpired.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreditCardExpired}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpired.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CreditCardExpired;
  return proto.no.jotta.openapi.subscription.v2.CreditCardExpired.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreditCardExpired} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreditCardExpired}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpired.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpired.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CreditCardExpired.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreditCardExpired} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreditCardExpired.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.HasPaymentIssues} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.HasPaymentIssues}
 */
proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.HasPaymentIssues;
  return proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.HasPaymentIssues} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.HasPaymentIssues}
 */
proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.HasPaymentIssues} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription}
 */
proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription;
  return proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription}
 */
proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.MessageCase = {
  MESSAGE_NOT_SET: 0,
  DUE_FOR_TERMINATION_OFFER: 1,
  CARD_EXPIRES_SOON: 2,
  CARD_EXPIRED: 3,
  PAYMENT_ISSUE: 4,
  EXPIRED_SUBSCRIPTION: 5
};

/**
 * @return {proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.MessageCase}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.getMessageCase = function() {
  return /** @type {proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.MessageCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    dueForTerminationOffer: (f = msg.getDueForTerminationOffer()) && proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.toObject(includeInstance, f),
    cardExpiresSoon: (f = msg.getCardExpiresSoon()) && proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.toObject(includeInstance, f),
    cardExpired: (f = msg.getCardExpired()) && proto.no.jotta.openapi.subscription.v2.CreditCardExpired.toObject(includeInstance, f),
    paymentIssue: (f = msg.getPaymentIssue()) && proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.toObject(includeInstance, f),
    expiredSubscription: (f = msg.getExpiredSubscription()) && proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.SubscriptionMessage;
  return proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.deserializeBinaryFromReader);
      msg.setDueForTerminationOffer(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.deserializeBinaryFromReader);
      msg.setCardExpiresSoon(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.subscription.v2.CreditCardExpired;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.CreditCardExpired.deserializeBinaryFromReader);
      msg.setCardExpired(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.subscription.v2.HasPaymentIssues;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.deserializeBinaryFromReader);
      msg.setPaymentIssue(value);
      break;
    case 5:
      var value = new proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.deserializeBinaryFromReader);
      msg.setExpiredSubscription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDueForTerminationOffer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer.serializeBinaryToWriter
    );
  }
  f = message.getCardExpiresSoon();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon.serializeBinaryToWriter
    );
  }
  f = message.getCardExpired();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.subscription.v2.CreditCardExpired.serializeBinaryToWriter
    );
  }
  f = message.getPaymentIssue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.no.jotta.openapi.subscription.v2.HasPaymentIssues.serializeBinaryToWriter
    );
  }
  f = message.getExpiredSubscription();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription.serializeBinaryToWriter
    );
  }
};


/**
 * optional DueForTerminationConvertOffer due_for_termination_offer = 1;
 * @return {?proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.getDueForTerminationOffer = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer, 1));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.DueForTerminationConvertOffer|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
*/
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.setDueForTerminationOffer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.clearDueForTerminationOffer = function() {
  return this.setDueForTerminationOffer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.hasDueForTerminationOffer = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CreditCardExpiresSoon card_expires_soon = 2;
 * @return {?proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.getCardExpiresSoon = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon, 2));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.CreditCardExpiresSoon|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
*/
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.setCardExpiresSoon = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.clearCardExpiresSoon = function() {
  return this.setCardExpiresSoon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.hasCardExpiresSoon = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CreditCardExpired card_expired = 3;
 * @return {?proto.no.jotta.openapi.subscription.v2.CreditCardExpired}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.getCardExpired = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.CreditCardExpired} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.CreditCardExpired, 3));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.CreditCardExpired|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
*/
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.setCardExpired = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.clearCardExpired = function() {
  return this.setCardExpired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.hasCardExpired = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional HasPaymentIssues payment_issue = 4;
 * @return {?proto.no.jotta.openapi.subscription.v2.HasPaymentIssues}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.getPaymentIssue = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.HasPaymentIssues} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.HasPaymentIssues, 4));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.HasPaymentIssues|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
*/
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.setPaymentIssue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.clearPaymentIssue = function() {
  return this.setPaymentIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.hasPaymentIssue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional HasExpiredSubscription expired_subscription = 5;
 * @return {?proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.getExpiredSubscription = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription, 5));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.HasExpiredSubscription|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
*/
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.setExpiredSubscription = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage} returns this
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.clearExpiredSubscription = function() {
  return this.setExpiredSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.prototype.hasExpiredSubscription = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.repeatedFields_ = [16,18];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_ = [[100,101,102,103,104,105,106,107,108,109,110]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ChangeSubscriptionOptionCase = {
  CHANGE_SUBSCRIPTION_OPTION_NOT_SET: 0,
  NORMAL_UPGRADE: 100,
  MANAGE_IN_PLAY_STORE: 101,
  MANAGE_IN_APP_STORE: 102,
  CONTACT_RESELLER: 103,
  CONTACT_SUPPORT: 104,
  CONTACT_FAMILY_OWNER: 105,
  CONTACT_BUSINESS_ADMIN: 106,
  MANAGE_IN_BUSINESS_PAGES: 107,
  CONVERT_FROM_RESELLER: 108,
  MANAGE_SUBSCRIPTION_EXTERNALLY: 109,
  SA_SUBSCRIPTION: 110
};

/**
 * @return {proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ChangeSubscriptionOptionCase}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getChangeSubscriptionOptionCase = function() {
  return /** @type {proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ChangeSubscriptionOptionCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentInfo: (f = msg.getPaymentInfo()) && proto.no.jotta.openapi.subscription.v2.PaymentInfo.toObject(includeInstance, f),
    subscriptionInterval: jspb.Message.getFieldWithDefault(msg, 2, 0),
    subscriptionNameLocalized: jspb.Message.getFieldWithDefault(msg, 3, ""),
    productNameLocalized: jspb.Message.getFieldWithDefault(msg, 4, ""),
    productCode: jspb.Message.getFieldWithDefault(msg, 22, ""),
    subscriptionQuotaBytes: jspb.Message.getFieldWithDefault(msg, 5, 0),
    subscriptionUsageBytes: jspb.Message.getFieldWithDefault(msg, 6, 0),
    customerQuotaBytes: jspb.Message.getFieldWithDefault(msg, 7, 0),
    customerUsageBytes: jspb.Message.getFieldWithDefault(msg, 8, 0),
    renewalDateMillis: (f = msg.getRenewalDateMillis()) && no_jotta_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    expirationDateMillis: (f = msg.getExpirationDateMillis()) && no_jotta_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    discountPercentage: jspb.Message.getFieldWithDefault(msg, 11, 0),
    price: (f = msg.getPrice()) && proto.no.jotta.openapi.subscription.v2.Money.toObject(includeInstance, f),
    canDowngrade: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    canUseVoucher: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    possiblePaymentIntervalsList: jspb.Message.toObjectList(msg.getPossiblePaymentIntervalsList(),
    proto.no.jotta.openapi.subscription.v2.PaymentInterval.toObject, includeInstance),
    credit: (f = msg.getCredit()) && proto.no.jotta.openapi.subscription.v2.Money.toObject(includeInstance, f),
    subscriptionMessagesList: jspb.Message.toObjectList(msg.getSubscriptionMessagesList(),
    proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.toObject, includeInstance),
    freeStorageLimit: jspb.Message.getFieldWithDefault(msg, 19, 0),
    numFamilyMembers: jspb.Message.getFieldWithDefault(msg, 20, 0),
    extraStorageBytes: jspb.Message.getFieldWithDefault(msg, 21, 0),
    extraSeats: jspb.Message.getFieldWithDefault(msg, 23, 0),
    normalUpgrade: (f = msg.getNormalUpgrade()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.toObject(includeInstance, f),
    manageInPlayStore: (f = msg.getManageInPlayStore()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.toObject(includeInstance, f),
    manageInAppStore: (f = msg.getManageInAppStore()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.toObject(includeInstance, f),
    contactReseller: (f = msg.getContactReseller()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.toObject(includeInstance, f),
    contactSupport: (f = msg.getContactSupport()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.toObject(includeInstance, f),
    contactFamilyOwner: (f = msg.getContactFamilyOwner()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.toObject(includeInstance, f),
    contactBusinessAdmin: (f = msg.getContactBusinessAdmin()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.toObject(includeInstance, f),
    manageInBusinessPages: (f = msg.getManageInBusinessPages()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.toObject(includeInstance, f),
    convertFromReseller: (f = msg.getConvertFromReseller()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.toObject(includeInstance, f),
    manageSubscriptionExternally: (f = msg.getManageSubscriptionExternally()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.toObject(includeInstance, f),
    saSubscription: (f = msg.getSaSubscription()) && proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.subscription.v2.PaymentInfo;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PaymentInfo.deserializeBinaryFromReader);
      msg.setPaymentInfo(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setSubscriptionInterval(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionNameLocalized(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductNameLocalized(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubscriptionQuotaBytes(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubscriptionUsageBytes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCustomerQuotaBytes(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCustomerUsageBytes(value);
      break;
    case 9:
      var value = new no_jotta_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setRenewalDateMillis(value);
      break;
    case 10:
      var value = new no_jotta_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,no_jotta_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setExpirationDateMillis(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscountPercentage(value);
      break;
    case 12:
      var value = new proto.no.jotta.openapi.subscription.v2.Money;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Money.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanDowngrade(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanUseVoucher(value);
      break;
    case 16:
      var value = new proto.no.jotta.openapi.subscription.v2.PaymentInterval;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PaymentInterval.deserializeBinaryFromReader);
      msg.addPossiblePaymentIntervals(value);
      break;
    case 17:
      var value = new proto.no.jotta.openapi.subscription.v2.Money;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Money.deserializeBinaryFromReader);
      msg.setCredit(value);
      break;
    case 18:
      var value = new proto.no.jotta.openapi.subscription.v2.SubscriptionMessage;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.deserializeBinaryFromReader);
      msg.addSubscriptionMessages(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFreeStorageLimit(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumFamilyMembers(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExtraStorageBytes(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExtraSeats(value);
      break;
    case 100:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.deserializeBinaryFromReader);
      msg.setNormalUpgrade(value);
      break;
    case 101:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.deserializeBinaryFromReader);
      msg.setManageInPlayStore(value);
      break;
    case 102:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.deserializeBinaryFromReader);
      msg.setManageInAppStore(value);
      break;
    case 103:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.deserializeBinaryFromReader);
      msg.setContactReseller(value);
      break;
    case 104:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.deserializeBinaryFromReader);
      msg.setContactSupport(value);
      break;
    case 105:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.deserializeBinaryFromReader);
      msg.setContactFamilyOwner(value);
      break;
    case 106:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.deserializeBinaryFromReader);
      msg.setContactBusinessAdmin(value);
      break;
    case 107:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.deserializeBinaryFromReader);
      msg.setManageInBusinessPages(value);
      break;
    case 108:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.deserializeBinaryFromReader);
      msg.setConvertFromReseller(value);
      break;
    case 109:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.deserializeBinaryFromReader);
      msg.setManageSubscriptionExternally(value);
      break;
    case 110:
      var value = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.deserializeBinaryFromReader);
      msg.setSaSubscription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.subscription.v2.PaymentInfo.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSubscriptionNameLocalized();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProductNameLocalized();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getSubscriptionQuotaBytes();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSubscriptionUsageBytes();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCustomerQuotaBytes();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCustomerUsageBytes();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getRenewalDateMillis();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      no_jotta_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getExpirationDateMillis();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      no_jotta_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getDiscountPercentage();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.no.jotta.openapi.subscription.v2.Money.serializeBinaryToWriter
    );
  }
  f = message.getCanDowngrade();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getCanUseVoucher();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getPossiblePaymentIntervalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.no.jotta.openapi.subscription.v2.PaymentInterval.serializeBinaryToWriter
    );
  }
  f = message.getCredit();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.no.jotta.openapi.subscription.v2.Money.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.no.jotta.openapi.subscription.v2.SubscriptionMessage.serializeBinaryToWriter
    );
  }
  f = message.getFreeStorageLimit();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getNumFamilyMembers();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeUint64(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeUint32(
      23,
      f
    );
  }
  f = message.getNormalUpgrade();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.serializeBinaryToWriter
    );
  }
  f = message.getManageInPlayStore();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.serializeBinaryToWriter
    );
  }
  f = message.getManageInAppStore();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.serializeBinaryToWriter
    );
  }
  f = message.getContactReseller();
  if (f != null) {
    writer.writeMessage(
      103,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.serializeBinaryToWriter
    );
  }
  f = message.getContactSupport();
  if (f != null) {
    writer.writeMessage(
      104,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.serializeBinaryToWriter
    );
  }
  f = message.getContactFamilyOwner();
  if (f != null) {
    writer.writeMessage(
      105,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.serializeBinaryToWriter
    );
  }
  f = message.getContactBusinessAdmin();
  if (f != null) {
    writer.writeMessage(
      106,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.serializeBinaryToWriter
    );
  }
  f = message.getManageInBusinessPages();
  if (f != null) {
    writer.writeMessage(
      107,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.serializeBinaryToWriter
    );
  }
  f = message.getConvertFromReseller();
  if (f != null) {
    writer.writeMessage(
      108,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.serializeBinaryToWriter
    );
  }
  f = message.getManageSubscriptionExternally();
  if (f != null) {
    writer.writeMessage(
      109,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.serializeBinaryToWriter
    );
  }
  f = message.getSaSubscription();
  if (f != null) {
    writer.writeMessage(
      110,
      f,
      proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.toObject = function(includeInstance, msg) {
  var f, obj = {
    upgradeButtonHint: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType} */ (reader.readEnum());
      msg.setUpgradeButtonHint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpgradeButtonHint();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType = {
  UPGRADE: 0,
  CHANGE_SUBSCRIPTION: 1,
  NO_UPGRADE_OPTIONS: 2
};

/**
 * optional UpgradeType upgrade_button_hint = 1;
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.prototype.getUpgradeButtonHint = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.UpgradeType} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade.prototype.setUpgradeButtonHint = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.toObject = function(includeInstance, msg) {
  var f, obj = {
    resellerSupportUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resellerName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResellerSupportUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResellerName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResellerSupportUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResellerName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string reseller_support_url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.prototype.getResellerSupportUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.prototype.setResellerSupportUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reseller_name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.prototype.getResellerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller.prototype.setResellerName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.toObject = function(includeInstance, msg) {
  var f, obj = {
    supportUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupportUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupportUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string support_url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.prototype.getSupportUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport.prototype.setSupportUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.toObject = function(includeInstance, msg) {
  var f, obj = {
    familyOwnerName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyOwnerName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFamilyOwnerName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string family_owner_name = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.prototype.getFamilyOwnerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner.prototype.setFamilyOwnerName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.toObject = function(includeInstance, msg) {
  var f, obj = {
    daysUntilTermination: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resellerName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDaysUntilTermination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResellerName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaysUntilTermination();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResellerName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string days_until_termination = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.prototype.getDaysUntilTermination = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.prototype.setDaysUntilTermination = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reseller_name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.prototype.getResellerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller.prototype.setResellerName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    providerName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProviderName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string provider_name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.prototype.getProviderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally.prototype.setProviderName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription;
  return proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional PaymentInfo payment_info = 1;
 * @return {?proto.no.jotta.openapi.subscription.v2.PaymentInfo}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getPaymentInfo = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.PaymentInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.PaymentInfo, 1));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.PaymentInfo|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setPaymentInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearPaymentInfo = function() {
  return this.setPaymentInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasPaymentInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SubscriptionInterval subscription_interval = 2;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getSubscriptionInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setSubscriptionInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string subscription_name_localized = 3;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getSubscriptionNameLocalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setSubscriptionNameLocalized = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string product_name_localized = 4;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getProductNameLocalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setProductNameLocalized = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string product_code = 22;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int64 subscription_quota_bytes = 5;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getSubscriptionQuotaBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setSubscriptionQuotaBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 subscription_usage_bytes = 6;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getSubscriptionUsageBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setSubscriptionUsageBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 customer_quota_bytes = 7;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getCustomerQuotaBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setCustomerQuotaBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 customer_usage_bytes = 8;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getCustomerUsageBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setCustomerUsageBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional no.jotta.protobuf.Int64Value renewal_date_millis = 9;
 * @return {?proto.no.jotta.protobuf.Int64Value}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getRenewalDateMillis = function() {
  return /** @type{?proto.no.jotta.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.Int64Value, 9));
};


/**
 * @param {?proto.no.jotta.protobuf.Int64Value|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setRenewalDateMillis = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearRenewalDateMillis = function() {
  return this.setRenewalDateMillis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasRenewalDateMillis = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional no.jotta.protobuf.Int64Value expiration_date_millis = 10;
 * @return {?proto.no.jotta.protobuf.Int64Value}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getExpirationDateMillis = function() {
  return /** @type{?proto.no.jotta.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, no_jotta_protobuf_wrappers_pb.Int64Value, 10));
};


/**
 * @param {?proto.no.jotta.protobuf.Int64Value|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setExpirationDateMillis = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearExpirationDateMillis = function() {
  return this.setExpirationDateMillis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasExpirationDateMillis = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int32 discount_percentage = 11;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getDiscountPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setDiscountPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Money price = 12;
 * @return {?proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getPrice = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Money} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.Money, 12));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Money|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool can_downgrade = 14;
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getCanDowngrade = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setCanDowngrade = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool can_use_voucher = 15;
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getCanUseVoucher = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setCanUseVoucher = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * repeated PaymentInterval possible_payment_intervals = 16;
 * @return {!Array<!proto.no.jotta.openapi.subscription.v2.PaymentInterval>}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getPossiblePaymentIntervalsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.subscription.v2.PaymentInterval>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.subscription.v2.PaymentInterval, 16));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.subscription.v2.PaymentInterval>} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setPossiblePaymentIntervalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.PaymentInterval=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.subscription.v2.PaymentInterval}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.addPossiblePaymentIntervals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.no.jotta.openapi.subscription.v2.PaymentInterval, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearPossiblePaymentIntervalsList = function() {
  return this.setPossiblePaymentIntervalsList([]);
};


/**
 * optional Money credit = 17;
 * @return {?proto.no.jotta.openapi.subscription.v2.Money}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getCredit = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Money} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.Money, 17));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Money|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setCredit = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearCredit = function() {
  return this.setCredit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasCredit = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated SubscriptionMessage subscription_messages = 18;
 * @return {!Array<!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage>}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getSubscriptionMessagesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage, 18));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage>} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setSubscriptionMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionMessage}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.addSubscriptionMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.no.jotta.openapi.subscription.v2.SubscriptionMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearSubscriptionMessagesList = function() {
  return this.setSubscriptionMessagesList([]);
};


/**
 * optional int64 free_storage_limit = 19;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getFreeStorageLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setFreeStorageLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 num_family_members = 20;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getNumFamilyMembers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setNumFamilyMembers = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional uint64 extra_storage_bytes = 21;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getExtraStorageBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setExtraStorageBytes = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearExtraStorageBytes = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasExtraStorageBytes = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional uint32 extra_seats = 23;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getExtraSeats = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setExtraSeats = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearExtraSeats = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasExtraSeats = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional NormalUpgrade normal_upgrade = 100;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getNormalUpgrade = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade, 100));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.NormalUpgrade|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setNormalUpgrade = function(value) {
  return jspb.Message.setOneofWrapperField(this, 100, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearNormalUpgrade = function() {
  return this.setNormalUpgrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasNormalUpgrade = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional ManageInPlayStore manage_in_play_store = 101;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getManageInPlayStore = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore, 101));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInPlayStore|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setManageInPlayStore = function(value) {
  return jspb.Message.setOneofWrapperField(this, 101, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearManageInPlayStore = function() {
  return this.setManageInPlayStore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasManageInPlayStore = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional ManageInAppStore manage_in_app_store = 102;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getManageInAppStore = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore, 102));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInAppStore|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setManageInAppStore = function(value) {
  return jspb.Message.setOneofWrapperField(this, 102, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearManageInAppStore = function() {
  return this.setManageInAppStore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasManageInAppStore = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional ContactReseller contact_reseller = 103;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getContactReseller = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller, 103));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactReseller|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setContactReseller = function(value) {
  return jspb.Message.setOneofWrapperField(this, 103, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearContactReseller = function() {
  return this.setContactReseller(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasContactReseller = function() {
  return jspb.Message.getField(this, 103) != null;
};


/**
 * optional ContactSupport contact_support = 104;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getContactSupport = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport, 104));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactSupport|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setContactSupport = function(value) {
  return jspb.Message.setOneofWrapperField(this, 104, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearContactSupport = function() {
  return this.setContactSupport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasContactSupport = function() {
  return jspb.Message.getField(this, 104) != null;
};


/**
 * optional ContactFamilyOwner contact_family_owner = 105;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getContactFamilyOwner = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner, 105));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactFamilyOwner|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setContactFamilyOwner = function(value) {
  return jspb.Message.setOneofWrapperField(this, 105, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearContactFamilyOwner = function() {
  return this.setContactFamilyOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasContactFamilyOwner = function() {
  return jspb.Message.getField(this, 105) != null;
};


/**
 * optional ContactBusinessAdmin contact_business_admin = 106;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getContactBusinessAdmin = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin, 106));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ContactBusinessAdmin|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setContactBusinessAdmin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 106, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearContactBusinessAdmin = function() {
  return this.setContactBusinessAdmin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasContactBusinessAdmin = function() {
  return jspb.Message.getField(this, 106) != null;
};


/**
 * optional ManageInBusinessPages manage_in_business_pages = 107;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getManageInBusinessPages = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages, 107));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageInBusinessPages|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setManageInBusinessPages = function(value) {
  return jspb.Message.setOneofWrapperField(this, 107, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearManageInBusinessPages = function() {
  return this.setManageInBusinessPages(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasManageInBusinessPages = function() {
  return jspb.Message.getField(this, 107) != null;
};


/**
 * optional ConvertFromReseller convert_from_reseller = 108;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getConvertFromReseller = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller, 108));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ConvertFromReseller|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setConvertFromReseller = function(value) {
  return jspb.Message.setOneofWrapperField(this, 108, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearConvertFromReseller = function() {
  return this.setConvertFromReseller(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasConvertFromReseller = function() {
  return jspb.Message.getField(this, 108) != null;
};


/**
 * optional ManageSubscriptionExternally manage_subscription_externally = 109;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getManageSubscriptionExternally = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally, 109));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.ManageSubscriptionExternally|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setManageSubscriptionExternally = function(value) {
  return jspb.Message.setOneofWrapperField(this, 109, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearManageSubscriptionExternally = function() {
  return this.setManageSubscriptionExternally(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasManageSubscriptionExternally = function() {
  return jspb.Message.getField(this, 109) != null;
};


/**
 * optional SASubscription sa_subscription = 110;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.getSaSubscription = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription, 110));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.SASubscription|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.setSaSubscription = function(value) {
  return jspb.Message.setOneofWrapperField(this, 110, proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.clearSaSubscription = function() {
  return this.setSaSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetPaymentInfoResponse.prototype.hasSaSubscription = function() {
  return jspb.Message.getField(this, 110) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest;
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentMethodsList: jspb.Message.toObjectList(msg.getPaymentMethodsList(),
    proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse;
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.deserializeBinaryFromReader);
      msg.addPaymentMethods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.oneofGroups_ = [[10,11]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.TypeCase = {
  TYPE_NOT_SET: 0,
  STRIPE: 10,
  VIPPS: 11
};

/**
 * @return {proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.TypeCase}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.getTypeCase = function() {
  return /** @type {proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.TypeCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    stripe: (f = msg.getStripe()) && proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.toObject(includeInstance, f),
    vipps: (f = msg.getVipps()) && proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod;
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.deserializeBinaryFromReader);
      msg.setStripe(value);
      break;
    case 11:
      var value = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.deserializeBinaryFromReader);
      msg.setVipps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStripe();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.serializeBinaryToWriter
    );
  }
  f = message.getVipps();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.toObject = function(includeInstance, msg) {
  var f, obj = {
    publishableKey: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe;
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishableKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublishableKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string publishable_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.prototype.getPublishableKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe.prototype.setPublishableKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps;
  return proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Stripe stripe = 10;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.getStripe = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe, 10));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Stripe|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.setStripe = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.clearStripe = function() {
  return this.setStripe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.hasStripe = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Vipps vipps = 11;
 * @return {?proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.getVipps = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps, 11));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.Vipps|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.setVipps = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.clearVipps = function() {
  return this.setVipps(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod.prototype.hasVipps = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated PaymentMethod payment_methods = 1;
 * @return {!Array<!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod>}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.prototype.getPaymentMethodsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod>} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.prototype.setPaymentMethodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod}
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.prototype.addPaymentMethods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.PaymentMethod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetSupportedPaymentMethodsResponse.prototype.clearPaymentMethodsList = function() {
  return this.setPaymentMethodsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.StripeClientState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.StripeClientState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.toObject = function(includeInstance, msg) {
  var f, obj = {
    successPath: jspb.Message.getFieldWithDefault(msg, 1, ""),
    failurePath: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.StripeClientState}
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.StripeClientState;
  return proto.no.jotta.openapi.subscription.v2.StripeClientState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.StripeClientState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.StripeClientState}
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuccessPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailurePath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.StripeClientState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.StripeClientState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccessPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFailurePath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string success_path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.prototype.getSuccessPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.StripeClientState} returns this
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.prototype.setSuccessPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string failure_path = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.prototype.getFailurePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.StripeClientState} returns this
 */
proto.no.jotta.openapi.subscription.v2.StripeClientState.prototype.setFailurePath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.oneofGroups_ = [[10,11]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.TypeCase = {
  TYPE_NOT_SET: 0,
  STRIPE: 10,
  VIPPS: 11
};

/**
 * @return {proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.TypeCase}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getTypeCase = function() {
  return /** @type {proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.TypeCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subscriptionInterval: jspb.Message.getFieldWithDefault(msg, 2, 0),
    extraStorageTb: jspb.Message.getFieldWithDefault(msg, 3, 0),
    extraUserSeats: jspb.Message.getFieldWithDefault(msg, 4, 0),
    voucherCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    stripe: (f = msg.getStripe()) && proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.toObject(includeInstance, f),
    vipps: (f = msg.getVipps()) && proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest;
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setSubscriptionInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExtraStorageTb(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExtraUserSeats(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoucherCode(value);
      break;
    case 10:
      var value = new proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.deserializeBinaryFromReader);
      msg.setStripe(value);
      break;
    case 11:
      var value = new proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.deserializeBinaryFromReader);
      msg.setVipps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStripe();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.serializeBinaryToWriter
    );
  }
  f = message.getVipps();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.toObject = function(includeInstance, msg) {
  var f, obj = {
    newPaymentMethodId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clientState: (f = msg.getClientState()) && proto.no.jotta.openapi.subscription.v2.StripeClientState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe;
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPaymentMethodId(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.subscription.v2.StripeClientState;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.StripeClientState.deserializeBinaryFromReader);
      msg.setClientState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.subscription.v2.StripeClientState.serializeBinaryToWriter
    );
  }
};


/**
 * optional string new_payment_method_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.getNewPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.setNewPaymentMethodId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.clearNewPaymentMethodId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.hasNewPaymentMethodId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StripeClientState client_state = 2;
 * @return {?proto.no.jotta.openapi.subscription.v2.StripeClientState}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.getClientState = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.StripeClientState} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.StripeClientState, 2));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.StripeClientState|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} returns this
*/
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.setClientState = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.clearClientState = function() {
  return this.setClientState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe.prototype.hasClientState = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.toObject = function(includeInstance, msg) {
  var f, obj = {
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    failureRedirectUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps;
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailureRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string redirect_url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string failure_redirect_url = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.getFailureRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.setFailureRedirectUrl = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.clearFailureRedirectUrl = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps.prototype.hasFailureRedirectUrl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SubscriptionInterval subscription_interval = 2;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getSubscriptionInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.setSubscriptionInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 extra_storage_tb = 3;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getExtraStorageTb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.setExtraStorageTb = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.clearExtraStorageTb = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.hasExtraStorageTb = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 extra_user_seats = 4;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getExtraUserSeats = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.setExtraUserSeats = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.clearExtraUserSeats = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.hasExtraUserSeats = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string voucher_code = 5;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getVoucherCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.setVoucherCode = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.clearVoucherCode = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.hasVoucherCode = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Stripe stripe = 10;
 * @return {?proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getStripe = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe, 10));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Stripe|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
*/
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.setStripe = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.clearStripe = function() {
  return this.setStripe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.hasStripe = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Vipps vipps = 11;
 * @return {?proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.getVipps = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps, 11));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.Vipps|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
*/
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.setVipps = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.clearVipps = function() {
  return this.setVipps(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderRequest.prototype.hasVipps = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.oneofGroups_ = [[10,11,12]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.TypeCase = {
  TYPE_NOT_SET: 0,
  STRIPE: 10,
  VIPPS: 11,
  REJECTED: 12
};

/**
 * @return {proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.TypeCase}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.getTypeCase = function() {
  return /** @type {proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.TypeCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    stripe: (f = msg.getStripe()) && proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.toObject(includeInstance, f),
    vipps: (f = msg.getVipps()) && proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.toObject(includeInstance, f),
    rejected: (f = msg.getRejected()) && proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse;
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = new proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.deserializeBinaryFromReader);
      msg.setStripe(value);
      break;
    case 11:
      var value = new proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.deserializeBinaryFromReader);
      msg.setVipps(value);
      break;
    case 12:
      var value = new proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.deserializeBinaryFromReader);
      msg.setRejected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStripe();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.serializeBinaryToWriter
    );
  }
  f = message.getVipps();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.serializeBinaryToWriter
    );
  }
  f = message.getRejected();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe;
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_number = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirmationUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps;
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmationUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirmationUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string confirmation_url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.prototype.getConfirmationUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps.prototype.setConfirmationUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected;
  return proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Stripe stripe = 10;
 * @return {?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.getStripe = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe, 10));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Stripe|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.setStripe = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.clearStripe = function() {
  return this.setStripe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.hasStripe = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Vipps vipps = 11;
 * @return {?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.getVipps = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps, 11));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Vipps|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.setVipps = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.clearVipps = function() {
  return this.setVipps(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.hasVipps = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional Rejected rejected = 12;
 * @return {?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.getRejected = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected, 12));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.Rejected|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.setRejected = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.clearRejected = function() {
  return this.setRejected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.PlaceOrderResponse.prototype.hasRejected = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest;
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_number = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeRequest.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_ = [[10,11,12,14,13]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.StatusCase = {
  STATUS_NOT_SET: 0,
  SUCCESS: 10,
  CARD_ACTION_REQUIRED: 11,
  CARD_SETUP_REQUIRED: 12,
  REDIRECT_REQUIRED: 14,
  REJECTED: 13
};

/**
 * @return {proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.StatusCase}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.getStatusCase = function() {
  return /** @type {proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.StatusCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.toObject(includeInstance, f),
    cardActionRequired: (f = msg.getCardActionRequired()) && proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.toObject(includeInstance, f),
    cardSetupRequired: (f = msg.getCardSetupRequired()) && proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.toObject(includeInstance, f),
    redirectRequired: (f = msg.getRedirectRequired()) && proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.toObject(includeInstance, f),
    rejected: (f = msg.getRejected()) && proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse;
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 11:
      var value = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.deserializeBinaryFromReader);
      msg.setCardActionRequired(value);
      break;
    case 12:
      var value = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.deserializeBinaryFromReader);
      msg.setCardSetupRequired(value);
      break;
    case 14:
      var value = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.deserializeBinaryFromReader);
      msg.setRedirectRequired(value);
      break;
    case 13:
      var value = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.deserializeBinaryFromReader);
      msg.setRejected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.serializeBinaryToWriter
    );
  }
  f = message.getCardActionRequired();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.serializeBinaryToWriter
    );
  }
  f = message.getCardSetupRequired();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.serializeBinaryToWriter
    );
  }
  f = message.getRedirectRequired();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.serializeBinaryToWriter
    );
  }
  f = message.getRejected();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success;
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientSecret: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired;
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string client_secret = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientSecret: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired;
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string client_secret = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired;
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected;
  return proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Success success = 10;
 * @return {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.getSuccess = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success, 10));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Success|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CardActionRequired card_action_required = 11;
 * @return {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.getCardActionRequired = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired, 11));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardActionRequired|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.setCardActionRequired = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.clearCardActionRequired = function() {
  return this.setCardActionRequired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.hasCardActionRequired = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional CardSetupRequired card_setup_required = 12;
 * @return {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.getCardSetupRequired = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired, 12));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.CardSetupRequired|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.setCardSetupRequired = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.clearCardSetupRequired = function() {
  return this.setCardSetupRequired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.hasCardSetupRequired = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional RedirectRequired redirect_required = 14;
 * @return {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.getRedirectRequired = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired, 14));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.RedirectRequired|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.setRedirectRequired = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.clearRedirectRequired = function() {
  return this.setRedirectRequired(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.hasRedirectRequired = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Rejected rejected = 13;
 * @return {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.getRejected = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected, 13));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.Rejected|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.setRejected = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.clearRejected = function() {
  return this.setRejected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.CheckAndConfirmStripeResponse.prototype.hasRejected = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.OrderItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.OrderItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    localizedName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    priceCents: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.OrderItem}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.OrderItem;
  return proto.no.jotta.openapi.subscription.v2.OrderItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.OrderItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.OrderItem}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalizedName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPriceCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.OrderItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.OrderItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocalizedName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.OrderItem} returns this
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string localized_name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.getLocalizedName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.OrderItem} returns this
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.setLocalizedName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.OrderItem} returns this
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 price_cents = 4;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.getPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.OrderItem} returns this
 */
proto.no.jotta.openapi.subscription.v2.OrderItem.prototype.setPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.Order.repeatedFields_ = [100];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.Order.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.Order} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.Order.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timestampMillis: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    statusLocalized: jspb.Message.getFieldWithDefault(msg, 19, ""),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    typeLocalized: jspb.Message.getFieldWithDefault(msg, 20, ""),
    interval: jspb.Message.getFieldWithDefault(msg, 7, 0),
    localizedDescription: jspb.Message.getFieldWithDefault(msg, 8, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 6, 0),
    priceCents: jspb.Message.getFieldWithDefault(msg, 9, 0),
    vatAmountCents: jspb.Message.getFieldWithDefault(msg, 10, 0),
    creditUsedCents: jspb.Message.getFieldWithDefault(msg, 11, 0),
    chargedCents: jspb.Message.getFieldWithDefault(msg, 12, 0),
    discountAmountCents: jspb.Message.getFieldWithDefault(msg, 13, 0),
    card: (f = msg.getCard()) && proto.no.jotta.openapi.subscription.v2.Card.toObject(includeInstance, f),
    billedToName: jspb.Message.getFieldWithDefault(msg, 15, ""),
    billedToEmail: jspb.Message.getFieldWithDefault(msg, 16, ""),
    receiptLink: jspb.Message.getFieldWithDefault(msg, 17, ""),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 18, ""),
    orderItemsList: jspb.Message.toObjectList(msg.getOrderItemsList(),
    proto.no.jotta.openapi.subscription.v2.OrderItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.Order}
 */
proto.no.jotta.openapi.subscription.v2.Order.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.Order;
  return proto.no.jotta.openapi.subscription.v2.Order.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.Order}
 */
proto.no.jotta.openapi.subscription.v2.Order.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestampMillis(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.Order.OrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusLocalized(value);
      break;
    case 4:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.Order.OrderType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeLocalized(value);
      break;
    case 7:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalizedDescription(value);
      break;
    case 6:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.Currency} */ (reader.readEnum());
      msg.setCurrency(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPriceCents(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVatAmountCents(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditUsedCents(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChargedCents(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscountAmountCents(value);
      break;
    case 14:
      var value = new proto.no.jotta.openapi.subscription.v2.Card;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Card.deserializeBinaryFromReader);
      msg.setCard(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBilledToName(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setBilledToEmail(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptLink(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    case 100:
      var value = new proto.no.jotta.openapi.subscription.v2.OrderItem;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.OrderItem.deserializeBinaryFromReader);
      msg.addOrderItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.Order.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.Order.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimestampMillis();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatusLocalized();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTypeLocalized();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getLocalizedDescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCurrency();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getVatAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCreditUsedCents();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getChargedCents();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getDiscountAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getCard();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.no.jotta.openapi.subscription.v2.Card.serializeBinaryToWriter
    );
  }
  f = message.getBilledToName();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBilledToEmail();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getReceiptLink();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOrderItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      100,
      f,
      proto.no.jotta.openapi.subscription.v2.OrderItem.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.OrderStatus = {
  UNKNOWN_ORDER_STATUS: 0,
  PENDING: 1,
  CREATED: 2,
  PROCESSING: 3,
  COMPLETED: 4,
  REJECTED: 5,
  CANCELLED: 6,
  FAILED: 7,
  REFUNDED: 8,
  PARTIALLY_REFUNDED: 9
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.OrderType = {
  UNKNOWN_ORDER_TYPE: 0,
  RENEWAL: 1,
  BUY: 2,
  CREDIT_NOTE: 3,
  SA: 4,
  SA_PROLONGED: 5,
  RTG: 6,
  PROLONGED: 7,
  VOUCHER: 8,
  VOUCHER_PROLONGED: 9,
  INVITE: 10,
  CCCHANGE: 11,
  FREE_BASE: 12,
  BUSINESS_BASE: 13,
  FAMILY_MEMBER_BASE: 14,
  SYSTEM_FORCED: 15,
  EXPIRE_CHANGE: 16,
  DUE_FOR_TERMINATION: 17,
  INTERVAL_CHANGE: 18,
  IAP_END: 19
};

/**
 * optional string order_number = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 timestamp_millis = 2;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getTimestampMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setTimestampMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional OrderStatus status = 3;
 * @return {!proto.no.jotta.openapi.subscription.v2.Order.OrderStatus}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getStatus = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.Order.OrderStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Order.OrderStatus} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string status_localized = 19;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getStatusLocalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setStatusLocalized = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional OrderType type = 4;
 * @return {!proto.no.jotta.openapi.subscription.v2.Order.OrderType}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getType = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.Order.OrderType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Order.OrderType} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string type_localized = 20;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getTypeLocalized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setTypeLocalized = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional SubscriptionInterval interval = 7;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string localized_description = 8;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getLocalizedDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setLocalizedDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Currency currency = 6;
 * @return {!proto.no.jotta.openapi.subscription.v2.Currency}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getCurrency = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.Currency} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Currency} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int64 price_cents = 9;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 vat_amount_cents = 10;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getVatAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setVatAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 credit_used_cents = 11;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getCreditUsedCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setCreditUsedCents = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 charged_cents = 12;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getChargedCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setChargedCents = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 discount_amount_cents = 13;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getDiscountAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setDiscountAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional Card card = 14;
 * @return {?proto.no.jotta.openapi.subscription.v2.Card}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getCard = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Card} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.Card, 14));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Card|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
*/
proto.no.jotta.openapi.subscription.v2.Order.prototype.setCard = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.clearCard = function() {
  return this.setCard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.hasCard = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string billed_to_name = 15;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getBilledToName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setBilledToName = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string billed_to_email = 16;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getBilledToEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setBilledToEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string receipt_link = 17;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getReceiptLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setReceiptLink = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string encoded_content_ref = 18;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * repeated OrderItem order_items = 100;
 * @return {!Array<!proto.no.jotta.openapi.subscription.v2.OrderItem>}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.getOrderItemsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.subscription.v2.OrderItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.subscription.v2.OrderItem, 100));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.subscription.v2.OrderItem>} value
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
*/
proto.no.jotta.openapi.subscription.v2.Order.prototype.setOrderItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 100, value);
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.OrderItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.subscription.v2.OrderItem}
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.addOrderItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 100, opt_value, proto.no.jotta.openapi.subscription.v2.OrderItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.subscription.v2.Order} returns this
 */
proto.no.jotta.openapi.subscription.v2.Order.prototype.clearOrderItemsList = function() {
  return this.setOrderItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetOrderRequest}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetOrderRequest;
  return proto.no.jotta.openapi.subscription.v2.GetOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetOrderRequest}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_number = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetOrderRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetOrderRequest.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.GetOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.GetOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    order: (f = msg.getOrder()) && proto.no.jotta.openapi.subscription.v2.Order.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetOrderResponse}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.GetOrderResponse;
  return proto.no.jotta.openapi.subscription.v2.GetOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetOrderResponse}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.subscription.v2.Order;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Order.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.GetOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.GetOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.subscription.v2.Order.serializeBinaryToWriter
    );
  }
};


/**
 * optional Order order = 1;
 * @return {?proto.no.jotta.openapi.subscription.v2.Order}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.prototype.getOrder = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.Order} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.subscription.v2.Order, 1));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.Order|undefined} value
 * @return {!proto.no.jotta.openapi.subscription.v2.GetOrderResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.subscription.v2.GetOrderResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.GetOrderResponse.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.ListOrdersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.ListOrdersRequest}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.ListOrdersRequest;
  return proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.ListOrdersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.ListOrdersRequest}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.ListOrdersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.ListOrdersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    proto.no.jotta.openapi.subscription.v2.Order.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.ListOrdersResponse}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.ListOrdersResponse;
  return proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.ListOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.ListOrdersResponse}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.subscription.v2.Order;
      reader.readMessage(value,proto.no.jotta.openapi.subscription.v2.Order.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.ListOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.subscription.v2.Order.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Order orders = 1;
 * @return {!Array<!proto.no.jotta.openapi.subscription.v2.Order>}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.subscription.v2.Order>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.subscription.v2.Order, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.subscription.v2.Order>} value
 * @return {!proto.no.jotta.openapi.subscription.v2.ListOrdersResponse} returns this
*/
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.Order=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.subscription.v2.Order}
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.subscription.v2.Order, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.subscription.v2.ListOrdersResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.ListOrdersResponse.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest;
  return proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    action: jspb.Message.getFieldWithDefault(msg, 2, 0),
    discountPercentage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    credit: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    duration: jspb.Message.getFieldWithDefault(msg, 5, 0),
    productMessageKey: jspb.Message.getFieldWithDefault(msg, 6, ""),
    renewalExpireTimeMillis: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse;
  return proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiscountPercentage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCredit(value);
      break;
    case 5:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setDuration(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductMessageKey(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRenewalExpireTimeMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDiscountPercentage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getProductMessageKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRenewalExpireTimeMillis();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus = {
  UNKNOWN_STATUS: 0,
  OPEN: 1,
  NOT_FOUND: 2,
  EXPIRED: 3,
  USED: 4
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction = {
  UNKNOWN_ACTION: 0,
  NEW_SUBSCRIPTION: 1,
  EXTEND_RENEWAL: 2,
  EXTEND_EXPIRE: 3,
  NO_CHANGE: 4,
  NEW_RECURRING_SUBSCRIPTION: 5
};

/**
 * optional VoucherStatus status = 1;
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.getStatus = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherStatus} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional VoucherAction action = 2;
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.getAction = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.VoucherAction} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 discount_percentage = 3;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.getDiscountPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.setDiscountPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double credit = 4;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.getCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.setCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional SubscriptionInterval duration = 5;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.getDuration = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.setDuration = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string product_message_key = 6;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.getProductMessageKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.setProductMessageKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 renewal_expire_time_millis = 7;
 * @return {number}
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.getRenewalExpireTimeMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.DescribeVoucherResponse.prototype.setRenewalExpireTimeMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentTicketId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest;
  return proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentTicketId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentTicketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string payment_ticket_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.prototype.getPaymentTicketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketRequest.prototype.setPaymentTicketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse;
  return proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CancelPaymentTicketResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest;
  return proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse;
  return proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.ApplyVoucherResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    isApp: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    interval: jspb.Message.getFieldWithDefault(msg, 3, 0),
    failureRedirectUrl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest;
  return proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsApp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailureRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsApp();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFailureRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool is_app = 1;
 * @return {boolean}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.getIsApp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.setIsApp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string redirect_url = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SubscriptionInterval interval = 3;
 * @return {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.getInterval = function() {
  return /** @type {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.subscription.v2.SubscriptionInterval} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.setInterval = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string failure_redirect_url = 4;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.getFailureRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentRequest.prototype.setFailureRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirmationUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentTicketId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    agreementId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse;
  return proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmationUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentTicketId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgreementId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirmationUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentTicketId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAgreementId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string confirmation_url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.getConfirmationUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.setConfirmationUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string payment_ticket_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.getPaymentTicketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.setPaymentTicketId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string agreement_id = 3;
 * @return {string}
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.getAgreementId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse} returns this
 */
proto.no.jotta.openapi.subscription.v2.CreateVippsIntentResponse.prototype.setAgreementId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.RecurringSubscriptionInterval = {
  NOT_SET_RECURRING: 0,
  MONTHLY_RECURRING: 1,
  YEARLY_RECURRING: 2
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.SubscriptionInterval = {
  NOT_SET: 0,
  MONTHLY: 1,
  YEARLY: 2,
  FIXED_1MND: 3,
  FIXED_2MND: 4,
  FIXED_3MND: 5,
  FIXED_6MND: 6,
  FIXED_12MND: 7,
  FIXED_24MND: 8,
  FIXED_36MND: 9,
  FIXED_60MND: 10
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.subscription.v2.Currency = {
  UNKNOWN_CURRENCY: 0,
  DKK: 1,
  EUR: 2,
  NOK: 3,
  SEK: 4,
  USD: 5
};

goog.object.extend(exports, proto.no.jotta.openapi.subscription.v2);
